module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23760",
      "conversations-internal-schema": "static-1.11616",
      "head-dlb": "static-1.4130",
      "hs-test-utils": "static-1.6981",
      "hubspot-url-utils": "static-1.3297",
      "HubStyleTokens": "static-2.10499",
      "I18n": "static-7.1398",
      "jasmine-runner": "static-1.5401",
      "quartz": "static-1.5738",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.466",
      "visitor-ui-component-library": "static-1.5171",
      "enviro": "static-4.310",
      "hs-promise-rejection-tracking": "static-1.4492",
      "PortalIdParser": "static-2.288",
      "raven": "static-3.4958",
      "raven-hubspot": "static-1.5265",
      "bend-plugin-trellis-migration": "static-1.2598",
      "moment": "static-3.26",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "quartz-core": "static-1.4957",
      "transmute": "static-2.29",
      "HeadJS": "static-2.583",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6203",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.2092",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.121",
      "foundations-theming": "static-1.3289",
      "i18n-data": "static-1.199",
      "metrics-js": "static-1.8748",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4463",
      "jasmine": "static-4.3327",
      "quartz-core-utils": "static-1.2605",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.39",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7446",
      "visitor-ui-component-library-icons": "static-1.4982",
      "copilot-toolkit": "static-1.7173",
      "dispatcher": "static-1.114",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.656",
      "hub-http-shared-msw-handlers": "static-1.7281",
      "hubspotter-http": "static-1.3728",
      "hubspotter-http-shared-msw-handlers": "static-1.7279",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.354",
      "platform-navigation-bootstrap": "static-1.11411",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15545",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-components": "static-1.2472",
      "floating-ui": "static-1.29",
      "foundations-assets": "static-1.3888",
      "foundations-theming-specialty": "static-1.1006",
      "hs-story-utils": "static-1.8348",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.74",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.876",
      "bend-plugin-foundations-theming": "static-1.1772",
      "foundations-theming-base": "static-1.2274",
      "classnames": "static-2.10",
      "cssUtils": "static-1.527",
      "HubStyle": "static-2.10807",
      "chatspot-client-types": "static-1.8891",
      "chatspot-core": "static-1.16514",
      "ts-schema": "static-1.3263",
      "sassPrefix": "static-1.132",
      "platform-infra-nav-components": "static-1.6836",
      "react-input-autosize": "static-2.17",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23760",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11616",
      "head-dlb": "/head-dlb/static-1.4130",
      "hs-test-utils": "/hs-test-utils/static-1.6981",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3297",
      "HubStyleTokens": "/HubStyleTokens/static-2.10499",
      "I18n": "/I18n/static-7.1398",
      "jasmine-runner": "/jasmine-runner/static-1.5401",
      "quartz": "/quartz/static-1.5738",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.466",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5171",
      "enviro": "/enviro/static-4.310",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4492",
      "PortalIdParser": "/PortalIdParser/static-2.288",
      "raven": "/raven/static-3.4958",
      "raven-hubspot": "/raven-hubspot/static-1.5265",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2598",
      "moment": "/moment/static-3.26",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "quartz-core": "/quartz-core/static-1.4957",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.583",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6203",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2092",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.121",
      "foundations-theming": "/foundations-theming/static-1.3289",
      "i18n-data": "/i18n-data/static-1.199",
      "metrics-js": "/metrics-js/static-1.8748",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4463",
      "jasmine": "/jasmine/static-4.3327",
      "quartz-core-utils": "/quartz-core-utils/static-1.2605",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.39",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7446",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4982",
      "copilot-toolkit": "/copilot-toolkit/static-1.7173",
      "dispatcher": "/dispatcher/static-1.114",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.656",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7281",
      "hubspotter-http": "/hubspotter-http/static-1.3728",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7279",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.354",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11411",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15545",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2472",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-assets": "/foundations-assets/static-1.3888",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1006",
      "hs-story-utils": "/hs-story-utils/static-1.8348",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.74",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.876",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1772",
      "foundations-theming-base": "/foundations-theming-base/static-1.2274",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.527",
      "HubStyle": "/HubStyle/static-2.10807",
      "chatspot-client-types": "/chatspot-client-types/static-1.8891",
      "chatspot-core": "/chatspot-core/static-1.16514",
      "ts-schema": "/ts-schema/static-1.3263",
      "sassPrefix": "/sassPrefix/static-1.132",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6836",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};